import { useQuery } from '../../../hooks/useQuery';
import { getDashboardStats, getProjectDashboardStats } from '../../../services/dashboard';

export function useDashboardStats(projectId?: string) {
  const queryFn = projectId 
    ? () => getProjectDashboardStats(projectId)
    : getDashboardStats;

  const {
    data: stats,
    isLoading,
    error,
    refetch
  } = useQuery(queryFn);

  return {
    stats: stats || {
      totalAnalyses: 0,
      totalCandidates: 0,
      totalJobs: 0,
      recentAnalyses: 0
    },
    isLoading,
    error,
    refetch
  };
}